module.exports = __webpack_public_path__ + "static/media/buildingConstruction14.6e6a4ed8.jpg";